/**
 * @description Manages window.storage
 * @returns storage objects
 * @class StorageManager
 */
export class StorageManager {
  /**
   * @description Set or update given value in localStorage
   * @static
   * @returns Object
   * @memberof StorageManager
   */
  static set(key, value) {
    if (key && value) {
      window.localStorage.setItem(key, value);
      return {
        success: true,
        data: "Storage has been set successfully."
      };
    }

    return {
      error: true,
      data: "Storage was not set. Storage key and value is required!"
    };
  }

  /**
   * @description Set or update given value in sessionStorage, used to not remember user after closing opened tab.
   * @static
   * @returns Object
   * @memberof StorageManager
   */
  static setToSession(key, value) {
    if (key && value) {
      window.sessionStorage.setItem(key, value);
      return {
        success: true,
        data: "Storage has been set successfully."
      };
    }

    return {
      error: true,
      data: "Storage was not set. Storage key and value is required!"
    };
  }

  /**
   * @description Fetch data from localStorage
   * @static
   * @returns Object
   * @memberof StorageManager
   */
  static get(key, defaultValue = undefined) {
    if (key) {
      const val = window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
      return val || defaultValue;
    }

    return {
      error: true,
      data: "Storage key is required!"
    };
  }

  /**
   * @description Clear only one value from localStorage
   * @static
   * @returns Object
   * @memberof StorageManager
   */
  static clearOne(key) {
    if (key === 'token') {
      localStorage.removeItem('trade-type');
      localStorage.removeItem('trade-value');
    }
    if (key) {
      window.localStorage.removeItem(key) ||
        window.sessionStorage.removeItem(key);
    }

    return "Storage key is required!";
  }

  /**
   * @description Clear all values from localStorage
   * @static
   * @returns Object
   * @memberof StorageManager
   */
  static clearAll() {
    window.localStorage.clear();
    window.sessionStorage.clear();
  }

  static hasKey(key) {
    return typeof this.get(key) === 'string';
  }

  static saveFilters(module, namespace, filters = {}, merge = false) {
    let savedFilters = this.get('filters');
    try {
      savedFilters = JSON.parse(savedFilters);
    } catch (e) {
      savedFilters = {};
    }
    if (!savedFilters) {
      savedFilters = {};
    }
    if (!savedFilters[module]) {
      savedFilters[module] = {};
    }
    if (!savedFilters[module][namespace]) {
      savedFilters[module][namespace] = {};
    }
    if (Object.keys(filters).length) {
      savedFilters[module][namespace] = merge ?
        Object.assign(savedFilters[module][namespace], filters) : filters;
    } else {
      savedFilters[module][namespace] = {};
    }
    this.set('filters', JSON.stringify(savedFilters))
    return savedFilters[module][namespace];
  }

  static getFilters(module, namespace) {
    let savedFilters = this.get('filters');
    try {
      savedFilters = JSON.parse(savedFilters);
    } catch (e) {
      savedFilters = {};
    }
    if (!savedFilters) {
      savedFilters = {};
    }
    if (!savedFilters[module]) {
      savedFilters[module] = {};
    }
    if (!savedFilters[module][namespace]) {
      savedFilters[module][namespace] = {};
    }
    return savedFilters[module][namespace];
  }
}
